export const SUCCESS_MESSAGE = 'Password has been reset';
export const EXPIRED_LINK_ERROR_MESSAGE = 'Sorry, your link was expired. Please try again';
